const getState = (state, storeName) => state[storeName] || {};
const getData = (state, storeName) => state[storeName].data || {};
const getPagination = (state, storeName) =>
    getState(state, storeName).pagination || getData(state, storeName).pagination || {};
const getAdditionalPagination = (state, storeName) => {
    const additionalPagination =
        getState(state, storeName).additionalPagination ||
        getData(state, storeName).additionalPagination ||
        {};
    return additionalPagination;
};

export default {
    getPagination,
    getAdditionalPagination,
};
